import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IVelvetActionProps } from "./VelvetAction.props";

const styles = {
  primary: "velvet-cut border-thread bg-thread text-ink hover:border-parchment hover:bg-parchment",
  secondary:
    "border-parchment/35 bg-transparent text-parchment hover:border-thread hover:text-thread",
  ghost:
    "border-transparent bg-transparent px-0 text-thread underline decoration-1 underline-offset-8 hover:text-parchment hover:underline-offset-4",
  destructive:
    "velvet-cut border-error-500 bg-error-500 text-ink hover:border-parchment hover:bg-parchment",
} as const;

export const VelvetAction = ({ action, className }: IVelvetActionProps) => {
  const Link = getComponent("Link");
  return (
    <Link
      aria-label={action.accessibilityLabel || undefined}
      className={cn(
        "inline-flex min-h-11 items-center justify-center gap-3 border px-5 py-3 font-velvet-mono text-xs font-bold leading-[1.4] tracking-[0.08em] transition-[background-color,border-color,color,text-underline-offset] duration-200 ease-out after:content-['↗'] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
        styles[action.style || "primary"],
        className,
      )}
      href={action.href}
      rel={action.openInNewTab ? "noopener noreferrer" : undefined}
      target={action.openInNewTab ? "_blank" : undefined}
    >
      {action.label}
    </Link>
  );
};

VelvetAction.displayName = "Content::VelvetAction";
